// extracted by mini-css-extract-plugin
export default {"container":"styles_container__J1T3p","title":"styles_title__YmQV4","description":"styles_description__CzJYa","buttonContainer":"styles_buttonContainer__QlslG"};